// extracted by mini-css-extract-plugin
export default {"modalCustom":"ModalText_modalCustom__SqKiX","background":"ModalText_background__ZZlph"};